(function () {

    function releaseGalleryScroll() {
        const galleries = document.querySelectorAll(
            ".js-media-list, .js-media-mobile-list"
        );

        galleries.forEach((element) => {
            const swiper =
                element.swiper ||
                element.querySelector(".swiper")?.swiper;

            if (!swiper || swiper.destroyed) return;

            // İlk ve son görselde dokunmatik kaydırmayı serbest bırak
            swiper.params.touchReleaseOnEdges = true;

            // Mouse wheel kaydırmasını serbest bırak
            if (
                swiper.params.mousewheel &&
                typeof swiper.params.mousewheel === "object"
            ) {
                swiper.params.mousewheel.releaseOnEdges = true;
            }

            // Galeri durumunu güncelle
            swiper.update();
        });
    }

    function swiperInit() {
        subSliderInit(true);
        sliderInit(true);
        popupSliderInit(true);

        const mainProductSection = document.querySelector(
            ".main-product-section"
        );

        if (
            mainProductSection?.dataset?.mainProductDifferentGallery === "true"
        ) {
            window.__mainProductDifferentGallery = true;

            subSliderInit(
                true,
                ".js-media-mobile-list",
                ".js-media-mobile-sublist"
            );

            sliderInit(
                true,
                ".js-media-mobile-list",
                ".js-media-mobile-sublist"
            );
        }

        // Galeri kaydırma ayarlarını uygula
        releaseGalleryScroll();
    }

    document.addEventListener("shopify:section:load", function (e) {
        if (!window.isSwiperInit) {
            swiperInit();
        }
    });

    document.addEventListener(
        "shopify:section:load",
        function () {
            swiperInit();
        },
        { once: true }
    );

    if (!window.isSwiperInit) {
        swiperInit();
    }

    // Slider'ın iki kez başlatılmasını önle
    window.isSwiperInit = true;

})();

/* (function () {
	function swiperInit() {
		subSliderInit(true);
		sliderInit(true);
		popupSliderInit(true);
		
		const mainProductSection = document.querySelector(".main-product-section");
		if (mainProductSection?.dataset?.mainProductDifferentGallery === "true") {
			window.__mainProductDifferentGallery = true;
			
			subSliderInit(true, ".js-media-mobile-list", ".js-media-mobile-sublist");
			sliderInit(true, ".js-media-mobile-list", ".js-media-mobile-sublist");
		}
	}

	document.addEventListener('shopify:section:load', function (e) {
		if (!window?.isSwiperInit) {
			swiperInit();
		}
	});

	document.addEventListener("shopify:section:load",function () {
			swiperInit();
		},
		{ once: true }
	);

	if (!window?.isSwiperInit) {
		swiperInit()
	}

	// This file is loaded from both the main-product.liquid and featured-product.liquid files
	// and is called twice. To avoid the variable being initialized and the slider being
	// instantiated multiple times, need to implement a isSwiperInit variable to prevent double initialization
	window.isSwiperInit = true;
})();
 */